<script>
    import { Row ,Col, Button } from "./index";
</script>
<Row>
    <Col>官方的文档连接：<a href="https://element.eleme.cn/#/zh-CN/component/installation" target="_blank">链接地址</a></Col>
    <Col text="svelte的版本劲量与官方做到一致，纯属为了学习"/>
    <Col text="2022年3月5日21:08:50"/>
    <Col text="当前的ui组件不是最终版本，后续会更新，更加简洁"/>
    <Col text="当前翻译版本的doc暂时没空去做，后续ui组件做完了，会防一个官网的文档"/>
</Row>
<Row><a href="#/row"><Button text="Layout布局"/></a></Row>
<Row><a href="#/Container"><Button text="Container布局容器"/></a></Row>
<Row><a href="#/icon"><Button text="Icon图标"/></a></Row>
<Row><a href="#/button"><Button text="Button按钮"/></a></Row>
<Row><a href="#/link"><Button text="Link 文字链接"/></a></Row>
<hr>
<Row><a href="#/radio"><Button text="radio 单选按钮"/></a></Row>
<Row><a href="#/checkbox"><Button text="checkbox 复选按钮，还没做"/></a></Row>